import { createActionCreator } from '../reduxUtil';
import requestManager from 'root/requestManager';

export const SET_DATA = 'SET_DATA';
export const setData = createActionCreator(SET_DATA);

export const SET_MENU_VIEW = 'SET_MENU_VIEW';
export const setMenuView = createActionCreator(SET_MENU_VIEW);

export const SET_TOAST_CONTENT = 'SET_TOAST_CONTENT';
export const setToastContent = createActionCreator(SET_TOAST_CONTENT);

export const SET_TOAST_OPEN = 'SET_TOAST_OPEN';
export const setToastOpen = createActionCreator(SET_TOAST_OPEN);

export const SET_TOAST_SEVERITY = 'SET_TOAST_SEVERITY';
export const setToastSeverity = createActionCreator(SET_TOAST_SEVERITY);

export const CLOSE_TOAST = 'CLOSE_TOAST';
export const closeToast = createActionCreator(CLOSE_TOAST);

export const submitContactForm = contact => dispatch => {
    requestManager
        .submitContactForm(contact)
        .then(() => {
            dispatch(
                setToastSuccess(
                    'Thank you for reaching out, I will get back to you soon!'
                )
            );
        })
        .catch(error => {
            console.error('Error submitting contact form:', error);
            dispatch(
                setToastError(
                    'An error occurred while submitting the contact form.'
                )
            );
        });
};

export const setToastSuccess = content => dispatch => {
    dispatch(setToastSeverity('success'));
    dispatch(setToastContent(content));
};

export const setToastError = content => dispatch => {
    dispatch(setToastSeverity('error'));
    dispatch(setToastContent(content));
};
